<div id="media-preview" class="flex justify-center absolute w-[100%] h-[100%] bg-black  top-0 left-0 bg-opacity-75 z-50" (click)="checkIfBlankClicked($event)">
    <span class="float-right text-3xl text-gray-400 cursor-pointer mr-5 mt-5 ml-5 hover:text-white" (click)="close()">✕</span>
    <div class="w-[58vh] m-auto">
        <app-carousel [slides]="slides" [activeSlideIndex]="startingIndex"></app-carousel>
    </div>
</div>